import type { ComponentProps, PropsWithChildren } from 'react';
import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { themeGet, width } from 'styled-system';

import GradientBlock from 'common/components/GradientBlock';
import { useIsObserved } from 'common/hooks/intersection-observer';

export interface TopBannerContentWrapperProps extends PropsWithChildren {
  startColor: string;
  endColor?: string;
  onView: () => void;
}

const UnstyledWrapper = styled(GradientBlock)<any>`
  ${width};
`;

const Wrapper = (props: ComponentProps<typeof UnstyledWrapper>) => (
  <UnstyledWrapper mb={['sp_16', 'sp_20', null, 'sp_24']} width={1} {...props} />
);

const TopBannerContentWrapper = ({
  onView,
  startColor,
  endColor,
  children,
  ...props
}: TopBannerContentWrapperProps) => {
  const [ref, isObserved] = useIsObserved();
  useEffect(() => {
    if (isObserved) {
      onView();
    }
  }, [isObserved, onView]);

  return (
    <Wrapper
      ref={ref}
      color={themeGet('colors.sys.neutral.border.strong')}
      startColor={startColor}
      endColor={endColor}
      {...props}
    >
      {children}
    </Wrapper>
  );
};

export default TopBannerContentWrapper;
